"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodType = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["CARD"] = "card";
    PaymentMethodType["ALIPAY"] = "alipay";
    PaymentMethodType["IDEAL"] = "ideal";
    PaymentMethodType["SEPA_DEBIT"] = "sepa_debit";
    PaymentMethodType["SOFORT"] = "sofort";
    PaymentMethodType["BANCONTACT"] = "bancontact";
    PaymentMethodType["GIROPAY"] = "giropay";
    PaymentMethodType["_"] = "...";
})(PaymentMethodType || (exports.PaymentMethodType = PaymentMethodType = {}));
